import { useCallback, useState } from "react";
import type { SortState } from "@src/features/clips/types/camera";

type UseCameraSearchSortOptions = {
  initialSearchQuery?: string;
  initialSortBy?: SortState;
};

type UseCameraSearchSortReturn = {
  searchQuery: string;
  setSearchQuery: (searchQuery: string) => void;
  sortBy: SortState;
  setSortBy: (sortBy: SortState) => void;
  reset: () => void;
};

export function useCameraSearchSort({
  initialSearchQuery = "",
  initialSortBy = null,
}: UseCameraSearchSortOptions = {}): UseCameraSearchSortReturn {
  const [searchQuery, setSearchQuery] = useState(initialSearchQuery);
  const [sortBy, setSortBy] = useState<SortState>(initialSortBy);

  const reset = useCallback(() => {
    setSearchQuery(initialSearchQuery);
    setSortBy(initialSortBy);
  }, [initialSearchQuery, initialSortBy]);

  return {
    searchQuery,
    setSearchQuery,
    sortBy,
    setSortBy,
    reset,
  };
}
